import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useGetCompanyOffices } from '~/data/companyOffices';
import { useAllCostCenters } from '~/data/costCenters';
import { Employee } from '~/data/employee';
import { useAllLegalEntities } from '~/data/legalEntity';
import { LegacyFieldReadMode } from '~/legacy-components/LegacyForms';
import { LegacyHeadingWithActions } from '~/legacy-components/LegacyLayout';

interface Props {
  employee: Employee;
}

export const LimitedEmploymentData = ({ employee }: Props) => {
  const { t } = useTranslation();
  const { legalEntities } = useAllLegalEntities();
  const { getOfficeById } = useGetCompanyOffices();
  const { costCenters } = useAllCostCenters();
  const workContact = employee?.empWorkContact;
  const empPosition = employee?.empPosition || employee?.empPositionPending;

  const legalEntity = legalEntities.find(
    (entity) => entity.fLegalEntityId === empPosition?.fEmpLegalEntity,
  );
  const costCenter = costCenters.find(
    (center) =>
      center.fCostCenterId === empPosition?.fEmpCostCenters[0]?.fEmpCostCenter,
  );
  const office = getOfficeById(workContact?.fEmpOfficeLoc)?.fOfficeName;

  return (
    <Grid direction={'column'} container>
      <LegacyHeadingWithActions heading={t('laEmploymentData')} />
      <LegacyFieldReadMode
        label={t('fEmpLegalEntity')}
        value={legalEntity?.fLegalEntityName}
      />
      <LegacyFieldReadMode
        label={t('laCostCenter')}
        value={costCenter?.fCostCenterName}
      />
      <LegacyFieldReadMode label={t('fEmpOfficeLoc')} value={office} />
    </Grid>
  );
};
